<div class="bottom-sheet-body">

    <div class="close-icon-container" (click)="next()">
        <mat-icon class="close-icon" inline=true svgIcon="close-tab-icon" mat-list-icon >
        </mat-icon>
    </div>

    <img class="success-image" src="../../../../assets/icons/green-check-circle.png" alt="confirm-image">
    <p class="text-center">
        {{ message ? message : 'Operação Realizada com Sucesso!'}}
    </p>

    <button mat-raised-button color="primary" (click)="next()">OK</button>

</div>